import { Product } from "libs/shared-models/src/lib/product-type";

export class UserResponse {
    public id: string = "";
    public email: string = "";
    public name: string = "";
    public companyName: string = "";
    public phoneNumber: string = "";
    public userLanguage: string = "";
    public product: string = Product.UNDEFINED;
}

export class RestaurantTeamUsersResponse {
    users: UserResponse[];
    count: number;
}